import { request } from '../index'


export function getPaymentMethods() {
    const data = {
        url: "payment-methods/"
    }
    return request(data)
}

export function getCustomPaymentMethods() {
    const data = {
        url: "payment-methods/custom/list/"
    }
    return request(data)
}

export function CreateCustomPaymentMethods(data) {
    return request({ url: "payment-methods/custom/", method: "POST", data });
}

export function DeleteCustomPaymentMethods(data) {
    return request({ url: "payment-methods/custom/", method: "DELETE", data });
}

export function UpdateCustomPaymentMethods(data) {
    return request({ url: "payment-methods/custom/", method: "PUT", data });
}


// WEBPACK FOOTER //
// ./src/api/payments/index.js